<div class="css-Seguimiento_Errores seguimiento_errores">
    <div class="css-Bloque_Seguimiento_Errores bloque_seguimiento_errores">
        <img src="assets/images/basecomponents-images/066efd26d385158125e9e25f472a18f1bcb26f31.png" width="50px"
            height="13px" class="css-Vector_Flecha_seguimiento vector_flecha_seguimiento">
        <div class="css-Marcador marcador">
            <p class="css-Marcador_Errores1 marcador_errores1">Error {{errorTrackingService.getCurrentError()+1}}</p>
            <p class="css-Marcador_Errores1-1 marcador_errores1_1">/{{errorTrackingService.getCantidadErrores()}}</p>
        </div>
        <div class="css-Acciones acciones">
            <div [class.disabled]="errorTrackingService.esPrimerError()"
                class="css-Enlace_icono_izquierda_chico-1 enlace_icono_izquierda_chico">
                <a (click)="errorTrackingService.previousError()"
                    class="css-a_Enlace_icono_izquierda_chico-1 a_enlace_icono_izquierda_chico">
                    <div class="css-Icono_Flecha_Izda_Chico-2 icono_flecha_izda_chico">
                        <img src="assets/images/basecomponents-images/vectors5554839.svg" width="10.8px" height="10.8px"
                            class="css-arrow_back-1 arrowback">
                    </div>
                    <p class="css-Texto_enlace-2 texto_enlace">Anterior</p>
                </a>
            </div>
            <div [class.disabled]="errorTrackingService.esUltimoError()"
                class="css-Enlace_icono_derecha_chico-1 enlace_icono_derecha_chico">
                <a (click)="errorTrackingService.nextError()"
                    class="css-a_Enlace_icono_derecha_chico-1 a_enlace_icono_derecha_chico">
                    <p class="css-Texto_enlace-3 texto_enlace" style="text-align: right;">Siguiente</p>
                    <div class="css-Icono_Flecha_Dcha_Chico-2 icono_flecha_dcha_chico">
                        <img src="assets/images/basecomponents-images/vectors55931032.svg" width="10.8px"
                            height="10.8px" class="css-arrow_forward-1 arrowforward">
                    </div>
                </a>
            </div>
        </div>
    </div>
</div>